var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-buy-tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _vm._v("UpUUp\n    "),
          _c(
            "el-tab-pane",
            { attrs: { label: "拼单优惠活动", name: "table" } },
            [
              _c("group-buy-table-pane", {
                ref: "group_buy_table_pane",
                on: { toConfig: _vm.handleConfig },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeName === "config"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "设置拼单优惠", name: "config" } },
                [
                  _c("group-buy-config-pane", {
                    attrs: { "group-buy-fn-id": _vm.groupBuyFnId },
                    on: { success: _vm.handleSuccess },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }